const activeClass = 'ribbon-active',
    timeout = 8000;

export default function rotatingMessageRibbon($list) {
    if (!$list) {
        return;
    }

    if ($list.nodeName !== 'UL') {
        throw new Error('function rotatingMessageRibbon requires a UL or OL element with LI children.');
    }

    function rotate() {
        const $active = $list.querySelector(`.${activeClass}`),
            $next = $active && $active.nextElementSibling ? $active.nextElementSibling : $list.children[0];

        if ($list.children.length === 1) {
            setTimeout(rotate, timeout);
            return;
        }

        if ($active) {
            fadeOut($active).then(() => {
                requestAnimationFrame(() => {
                    fadeIn($next).then(() => {
                        setTimeout(rotate, timeout);
                    });
                });
            });
        } else {
            fadeIn($next).then(() => {
                setTimeout(rotate, timeout);
            });
        }
    }

    if ($list.children.length) {
        showFirst($list.children[0]);
        setTimeout(rotate, timeout);
    }
}

function showFirst($element) {
    $element.style.transitionDuration = 0;
    $element.style.opacity = 1;
    $element.style.display = 'list-item';
    $element.style.removeProperty('transition-duration');
    $element.classList.add(activeClass);
}

function fadeIn($element) {
    return new Promise(resolve => {
        $element.style.display = 'list-item';

        setTimeout(() => {
            oneTimeTransitionEndListener($element, () => {
                $element.classList.add(activeClass);
                resolve($element);
            });

            $element.style.opacity = 1;
        }, 0);
    });
}

function fadeOut($element) {
    return new Promise(resolve => {
        oneTimeTransitionEndListener($element, () => {
            $element.classList.remove(activeClass);
            $element.style.display = 'none';
            resolve($element);
        });

        setTimeout(() => {
            $element.style.opacity = 0;
        }, 0);
    });
}

function oneTimeTransitionEndListener($element, callback) {
    $element.addEventListener('transitionend', function end(event) {
        if (event.target !== $element) {
            return;
        }

        $element.removeEventListener('transitionend', end);
        callback();
    });
}
